export const COURSE_NOT_OPEN_MSG = '您还未开通学习功能，请与助学机构联系'

export function isCourseOpened(isOpen) {
  return String(isOpen) === '1'
}

export function checkCourseOpened(isOpen, vm) {
  if (isCourseOpened(isOpen)) {
    return true
  }
  if (vm && vm.$refs.courseOpenTip) {
    vm.$refs.courseOpenTip.open()
  } else if (vm) {
    vm.$message.error(COURSE_NOT_OPEN_MSG)
  }
  return false
}
